module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize | grids',

  render: function () {
    this.trackEvent({
      eventAction: 'show',
      eventLabel: ''
    });
  }
};
